/**
 * Common read-only tree helpers.
 *
 * These helpers deliberately accept both a node and a node array because the
 * menu API and Vue Router route records use the same `children` convention.
 */
function isRecord(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

/**
 * Returns a new pre-order array of all supplied tree nodes. The original tree
 * and its children arrays are never modified.
 */
export function flattenMenuTree(tree) {
  const flattened = [];

  function visit(nodes) {
    const list = Array.isArray(nodes) ? nodes : nodes ? [nodes] : [];

    list.forEach(function(node) {
      if (!isRecord(node)) {
        return;
      }

      flattened.push(node);
      visit(node.children);
    });
  }

  visit(tree);
  return flattened;
}

/**
 * Finds the first directly authorised leaf route in display order. Component
 * existence is intentionally not checked here; router integration performs
 * that separate concern before using the returned API path as a redirect.
 */
export function getFirstNavigablePath(tree) {
  const nodes = Array.isArray(tree) ? tree : tree ? [tree] : [];

  for (let index = 0; index < nodes.length; index += 1) {
    const node = nodes[index];
    if (!isRecord(node)) {
      continue;
    }

    const childPath = getFirstNavigablePath(node.children);
    if (childPath) {
      return childPath;
    }

    if (
      node.isAuthorized &&
      !node.isContainer &&
      typeof node.path === "string" &&
      node.path &&
      node.path !== "/Layout"
    ) {
      return node.path;
    }
  }

  return null;
}

export default {
  flattenMenuTree: flattenMenuTree,
  getFirstNavigablePath: getFirstNavigablePath,
};
